import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getCertificateRegistrationDate = (fiscalType: string) => {
  const ft = Number(fiscalType)
  return {
    date: {
      label: {
        eng: ft === FiscalType.IP
          ? 'Date of registration IP*'
          : ft === FiscalType.JSC
          ? 'Date of registration JSC*'
          : ft === FiscalType.PJSC
          ? 'Date of registration PJSC*'
          : ft === FiscalType.CJSC
          ? 'Date of registration CJSC*'
          : ft === FiscalType.LLP
          ? 'Date of registration LLP*'
          : 'Date of registration LLP*',
        rus: ft === FiscalType.IP
          ? 'Дата регистрации ИП*'
          : ft === FiscalType.JSC
          ? 'Дата регистрации АО*'
          : ft === FiscalType.PJSC
          ? 'Дата регистрации ПАО*'
          : ft === FiscalType.CJSC
          ? 'Дата регистрации ЗАО*'
          : ft === FiscalType.LLP
          ? 'Дата регистрации ТОО*'
          : 'Дата регистрации ООО*',
        kz: ft === FiscalType.IP
          ? 'Тіркеу күні IP*'
          : ft === FiscalType.JSC
          ? 'Тіркеу күні АҚ*'
          : ft === FiscalType.PJSC || ft === FiscalType.CJSC
          ? 'Тіркеу күні ЖАҚ*'
          : ft === FiscalType.LLP
          ? 'Тіркеу күні ЖШС*'
          : 'Тіркеу күні ЖШС*',
      },
      placeholder: {
        eng: 'dd.mm.yyyy',
        rus: 'дд.мм.гггг',
        kz: 'ГГГГ.ДД.ММ',
      },
      invalidText: {
        eng: 'Enter the registration date correctly',
        rus: 'Введите дату регистрации корректно',
        kz: 'Тіркеу күнін дұрыс енгізіңіз',
      },
    },
  }
}
